<script setup>
import UseSvg from "components/jiffy/vue-cart/UseSvg.vue";

const types = {
  delete: {
    text: "Delete",
    icon: "trash"
  },
  cancel: {
    text: "Cancel",
    icon: "cross"
  }
};

const emit = defineEmits(["action"]);
const props = defineProps({
  type: {
    type: String,
    required: true
  }
});
const type = types[props.type];
</script>

<template>
  <button class="upload-action" @click="emit('action')">
    <UseSvg class="upload-action__icon" :icon="type.icon" type="print" />
    {{ type.text }}
  </button>
</template>

<style scoped lang="scss">
@import "frontend/init/pod/settings";
@import "frontend/init/jiffy/mixin";
@import "frontend/init/jiffy/button/mixin";

.upload-action {
  $this: &;

  @include clear-button;

  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  width: 94px;
  height: 32px;
  color: $pod-gray-modern-900;
  border: 1px solid $pod-gray-modern-200;
  border-radius: 6px;

  &__icon {
    width: 24px;
    height: 24px;
    margin-right: 4px;
  }
}
</style>
